import { StanLoader } from '@/components';
import { useStanRouter } from '@/hooks/useStanRouter';
import { useAuthStore } from '@/stores';
import { useEffect, useMemo } from 'react';
import { useAuthTokenCheckUpgradeMutation } from '@/features/auth/queries';
import { useSearchParams } from 'react-router-dom';
import { stanNotify } from '@/lib';

export default function AuthPage() {
    const [searchParams] = useSearchParams();
    // Ensures we only run the effect once when the page loads
    const authToken = useMemo(() => searchParams.get('token') ?? null, [searchParams]);
    const { mutateAsync: checkAuthTokenUpgradeAsyncMutate } = useAuthTokenCheckUpgradeMutation();
    const saveToken = useAuthStore(state => state.saveToken);
    const setLoginApiData = useAuthStore(state => state.setLoginApiData);
    const { push } = useStanRouter();

    const checkAuthTokenUpgrade = async (token: string) => {
        try {
            const data = await checkAuthTokenUpgradeAsyncMutate({ authToken: token });
            if (data?.token) {
                saveToken(data.token, { tmpLoginAsAdmin: true });
            } else {
                setLoginApiData(data);
            }
        } catch {
            console.error('Error checking auth token upgrade');
            saveToken(token, { tmpLoginAsAdmin: true });
        }
    };

    useEffect(() => {
        if (!authToken) {
            stanNotify({
                type: 'error',
                title: 'Oops.',
                text: 'Something went wrong. Please try again later.',
                duration: 2000,
            });
            push('/login');
        } else {
            checkAuthTokenUpgrade(authToken);
            push('/dashboard');
        }
    }, [authToken]);

    return (
        <div className='flex h-screen w-full flex-col items-center justify-center align-middle'>
            <div>
                <div className='text-heading-heading2 pb-3'>Validating token...</div>
                <StanLoader />
            </div>
        </div>
    );
}
